define.alias("shared/components/shared/post/secondary/caption-writer/form", "settings/components/shared/post/secondary/caption-writer/form");